import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { useAuthStore } from '../../store/authStore';
import { useThemeStore } from '../../store/themeStore';  
import { Button } from 'primereact/button';
import { useSidebarStore } from '../../store/sidebarStore';
import { OverlayPanel } from 'primereact/overlaypanel'; 
import useSize from '../ui/useSize';
import NotificationsList from '../ui/NotificationsList';
import { initializeOneSignal } from '../../services/oneSignal';
import { Menu } from 'primereact/menu';

export default function Header() {
  const navigate = useNavigate();
  const { setUser } = useAuthStore();
  const { theme, toggleTheme } = useThemeStore();
  const { menuOpen, setMenuOpen } = useSidebarStore();
  const windowsize = useSize();
  const [notifications, setNotifications] = useState([]);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const op = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (isAuthenticated) {
      initializeOneSignalAndLoadNotifications();
    }
  }, [isAuthenticated]);

  const initializeOneSignalAndLoadNotifications = async () => {
    try {
      const userId = localStorage.getItem('userId');
      if (userId) {
        const userNotifications = await initializeOneSignal(userId);
        setNotifications(userNotifications);
      }
    } catch (error) {
      console.error('OneSignal initialization error:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    setUser(null);
    setNotifications([]);
    navigate('/login');
  };
  
  const toggleSidebar = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleNotifications = (event) => {
    op.current.toggle(event);
  };

  const userName = useAuthStore((state) => state.userName);

  const menuItems = [
    { label: 'Hesabım', icon: 'pi pi-user', command: () => navigate('/admin/account') },
    { label: 'Çıkış Yap', icon: 'pi pi-sign-out', command: handleLogout },
  ];

  return (
    <header className="py-2 shadow-2">
      <div className={`pt-1 mr-1 ml-2 flex ${windowsize[0] <= 1000 ? "justify-content-between" : "justify-content-end"} align-items-center`}>
        <Button 
          size='small'
          icon="pi pi-bars"
          text
          visible={windowsize[0] <= 1000}
          onClick={toggleSidebar}
          className="p-button-text"
        />
        <div className={`w-full text-center mx-4 justify-content-between align-content-between ${windowsize[0] <= 1000 ? "hidden" : "flex"}`}>
          <div>
            <span className="font-bold">Boyer Müşteri Portalı</span>
          </div>
          <div>
            <span className="font-bold">Hoşgeldin {userName}</span>
          </div>
        </div>
        <div className="flex align-items-center gap-2">
          <Button
            size='small'
            icon="pi pi-bell"
            text
            onClick={toggleNotifications}
            className="p-button-text"
            badge={notifications.length.toString()}
            badgeClassName="p-badge-danger"
          />
          <Button 
            size='small'
            icon={theme === 'light' ? 'pi pi-moon' : 'pi pi-sun'}
            text
            onClick={toggleTheme}
            className="p-button-text"
          />
          <Button
            size='small'
            icon="pi pi-user"
            text
            onClick={(event) => menuRef.current.toggle(event)}
            className="p-button-text"
          />
        </div>

        <OverlayPanel ref={op} className="w-11 md:w-30rem m-3 shadow-5">
          <div className="text-xl font-bold mb-3 p-3 border-bottom-1 surface-border">
            Bildirimler
          </div>
          <NotificationsList notifications={notifications} />
        </OverlayPanel>

        <Menu model={menuItems} popup ref={menuRef} />
      </div>
    </header>
  );
}
